import {
  EVICT_APPLICATION_CACHE,
  FETCH_ALL_INBOUND_FORMS,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS,
  FETCH_APPLICATION_REQUEST,
  FETCH_APPLICATION_SUCCESS,
  FETCH_AVAILABLE_PLATFORMS_SUCCESS,
  SET_APPLICATION_COUNT,
} from './applicationType';

const initialState = {
  applications: {},
  applicationCount: {
    pending: 0,
    rejected: 0,
    incomplete: 0,
    approved: 0,
  },
  applicationForms: [],
  isLoading: true,
  isFetchingConversionRates: false,
  conversionRate: {
    visitors: 0,
    optIns: 0,
    optInsRate: 0,
    applications: 0,
    applicationsRate: 0,
    approved: 0,
    approvalRate: 0,
    rejected: 0,
    rejectionRate: 0,
  },
  platforms: {
    instagram: false,
    youtube: false,
    tiktok: false,
    facebook: false,
    twitter: false,
  },
};

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_APPLICATION_SUCCESS:
      return {
        ...state,
        applications: action.payload.applications,
        isLoading: false,
      };
    case SET_APPLICATION_COUNT:
      return {
        ...state,
        applicationCount: {
          ...state.applicationCount,
          [action.payload.approvalStatus]: action.payload.count,
        },
      };
    case EVICT_APPLICATION_CACHE:
      return {
        ...state,
        applications: {},
        applicationCount: {
          pending: 0,
          rejected: 0,
          incomplete: 0,
          approved: 0,
        },
      };

    case FETCH_ALL_INBOUND_FORMS: {
      return {
        ...state,
        applicationForms: action.payload,
      };
    }

    case FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST: {
      return {
        ...state,
        isFetchingConversionRates: true,
      };
    }

    case FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS: {
      return {
        ...state,
        conversionRate: action.payload,
        isFetchingConversionRates: false,
      };
    }

    case FETCH_AVAILABLE_PLATFORMS_SUCCESS: {
      return {
        ...state,
        platforms: action.payload,
      };
    }

    default:
      return { ...state };
  }
};

export default applicationReducer;
